<template>
  <div class="p-login-form-suppl p-login-form-suppl--btn">
    <a class="p-login-form-suppl__link" :href="loginUrl">ログイン画面に戻る</a>
  </div>
</template>

<script>
export default {
  props: {
    loginUrl: String,
  },
}
</script>
